import * as THREE from "three";

exports.Unify = function(unify) {
  this.unify_id = "tuneNuggets";

  unify.assetLoader.loadGLTF("./objects/ring.glb");
  unify.assetLoader.loadGLTF("./objects/pyramid.glb");
  unify.assetLoader.loadGLTF("./objects/spikeCube.glb");

  const tuneNuggetPositions = [];
  const dummyMeshGroup = new THREE.Group();
  dummyMeshGroup.name = "dummyMeshes";
  const tuneNuggetsMeshes = new THREE.Group();
  tuneNuggetsMeshes.name = "tuneNuggets";

  this.onLoaded = () => {
    // set new materials
    let ringMat = new THREE.MeshStandardMaterial({ color: 0x888888, emissive: 0x00fafa, skinning: true });
    unify.objectTools.setMaterials(unify.assets.models.ring.scene, ringMat);
    let spikeCubeMat = new THREE.MeshStandardMaterial({ color: 0x555555, emissive: 0xff0000, skinning: true });
    unify.objectTools.setMaterials(unify.assets.models.spikeCube.scene, spikeCubeMat);
    let pyramidMat = new THREE.MeshStandardMaterial({ color: 0x000000, emissive: 0x000000, skinning: true });
    unify.objectTools.setMaterials(unify.assets.models.pyramid.scene, pyramidMat);
    /* ------------------------
     * TUNENUGGETS Installation
     * Generate arrays of randomized positions on the terrain and place TN objects at each position
     */
    let i = 0;
    while (i < unify.assets.settings.numberOfTuneNuggets) {
      let pos = unify.modules.gameLogic.RandomSpawnPoint();
      let shortestDist = unify.assets.settings.terrainSize;

      for (let i = 0; i < tuneNuggetPositions.length; i++) {
        let dist = pos.distanceTo(tuneNuggetPositions[i]);
        if (dist < shortestDist) {
          shortestDist = dist;
        }
      }
      // If distance is ok, push it!
      if (shortestDist > unify.assets.settings.minNuggetDistance) {
        tuneNuggetPositions.push(pos);
        i++;
      }
    }

    // Make copys of positions array
    let evilTuneNuggetPositions = [...tuneNuggetPositions];
    let happyTuneNuggetPositions = [...tuneNuggetPositions];
    // Trim arrays to appropriate size
    evilTuneNuggetPositions.splice(-unify.assets.settings.numberOfHappyTuneNuggets, unify.assets.settings.numberOfHappyTuneNuggets);
    happyTuneNuggetPositions.splice(0, evilTuneNuggetPositions.length);

    // TuneNugget Object
    const nuggetObjectGenerator = position => {
      let newNugget = new Object(); // storage container for nugget info
      newNugget.position = position; // store position ref
      newNugget.isFound = false;
      // add the dummy mesh
      let dummyMesh = unify.create.plane(); // <-- these are needed for the positional sound object
      newNugget.dummyMesh = dummyMesh; // store mesh ref
      dummyMesh.visible = false;
      dummyMesh.position.set(position.x, position.y + 2, position.z);
      dummyMeshGroup.add(dummyMesh);
      //add default (common) mesh
      newNugget.defaultMesh = unify.objectTools.deepClone(unify.assets.models.pyramid);
      newNugget.defaultMesh.position.copy(position);
      tuneNuggetsMeshes.add(newNugget.defaultMesh);
      newNugget.defaultMesh.userData.animations.animation_0.play();
      newNugget.defaultMesh.userData.animations.animation_0.time = Math.random() * newNugget.defaultMesh.userData.animations.animation_0._clip.duration;
      newNugget.defaultMesh.position.y += 1;
      return newNugget;
    };

    // Create array of evilObjects
    unify.addNewAsset("evilTuneNuggets", []);
    evilTuneNuggetPositions.forEach(position => {
      let newNugget = nuggetObjectGenerator(position);
      // add hidden mesh
      newNugget.hiddenMesh = unify.objectTools.deepClone(unify.assets.models.spikeCube);
      newNugget.hiddenMesh.position.copy(position);
      tuneNuggetsMeshes.add(newNugget.hiddenMesh);
      newNugget.hiddenMesh.scale.set(0.001, 0.001, 0.001);
      newNugget.hiddenMesh.position.y += 1;
      newNugget.hiddenMesh.userData.animations.animation_0.play();
      // push
      unify.assets.evilTuneNuggets.push(newNugget);
    });

    // Create array of happyObjects
    unify.addNewAsset("happyTuneNuggets", []);
    happyTuneNuggetPositions.forEach(position => {
      let newNugget = nuggetObjectGenerator(position);
      // add hidden mesh
      newNugget.hiddenMesh = unify.objectTools.deepClone(unify.assets.models.ring);
      newNugget.hiddenMesh.position.copy(position);
      tuneNuggetsMeshes.add(newNugget.hiddenMesh);
      newNugget.hiddenMesh.scale.set(0.001, 0.001, 0.001);
      newNugget.hiddenMesh.position.y += 2;
      newNugget.hiddenMesh.userData.animations.animation_0.play();
      // push
      unify.assets.happyTuneNuggets.push(newNugget);
    });

    // put meshes in the scene
    unify.scene.add(dummyMeshGroup);
    unify.scene.add(tuneNuggetsMeshes);
    /* ------------------------
     */
  };

  this.update = deltaTime => {
    unify.assets.evilTuneNuggets.forEach(nugget => {
      nugget.defaultMesh.userData.mixer.update(deltaTime);
    });
    unify.assets.happyTuneNuggets.forEach(nugget => {
      nugget.defaultMesh.userData.mixer.update(deltaTime);
    });
  };

  this.swapNuggetMesh = nugget => {
    nugget.defaultMesh.scale.set(0.001, 0.001, 0.001);
    nugget.defaultMesh = nugget.hiddenMesh;
    nugget.defaultMesh.scale.set(1, 1, 1);
  };
};
